import {
  Button,
  IconFunctionalSuccessCircle16,
  Image,
  Modal,
  UIHeading1,
  UIHeading2,
  UIText1,
  useDeviceType,
} from '@cian/ui-kit';
import * as React from 'react';
import { QUALITY_CRITERIA_LIST } from './constants';

import styles from './styles.css';
import cx from 'clsx';

// @ts-ignore
import QualityImg from './assets/quality.png';

interface IQualityCriteriaModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

export const QualityCriteriaModal: React.FC<IQualityCriteriaModalProps> = ({ isOpen, handleClose }) => {
  const device = useDeviceType();
  const isDesktop = device === 'desktop';
  const Title = isDesktop ? UIHeading1 : UIHeading2;

  return (
    <Modal
      open={isOpen}
      onOpenChange={handleClose}
      footer={
        <div className={cx(styles['quality-criteria_footer'], styles[device])}>
          <Button onClick={handleClose} fullWidth={!isDesktop}>
            Круто!
          </Button>
        </div>
      }
    >
      <div className={styles['container']}>
        <div className={styles['quality-criteria_image']}>
          <Image src={QualityImg} />
        </div>
        <div className={cx(styles['quality-criteria_content'], styles[device])}>
          <Title>Критерии качества агентов Циана</Title>
          <div className={styles['quality-criteria_list']}>
            {QUALITY_CRITERIA_LIST.map((criteria, index) => (
              <div key={index} className={styles['quality-criteria_item']}>
                <div className={styles['quality-criteria_icon']}>
                  <IconFunctionalSuccessCircle16 color="icon-positive-default" width={16} height={16} />
                </div>
                <UIText1>{criteria}</UIText1>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};
